module.exports = __webpack_public_path__ + "img/zhetong.05258548.png";